module.exports = __webpack_public_path__ + "images/emoji/eyes.ec7b382839c5252a7890.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/eyes.png
// module id = gbNM
// module chunks = 24